






import { Vue, Prop, Component } from 'vue-property-decorator';

@Component
export default class ListItemWithBorder extends Vue {
  @Prop() hasError!: boolean;
  @Prop() selected!: boolean;
}
